import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about')({
  component: About,
})

function About() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="border-4 border-dashed border-gray-200 rounded-lg p-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">About Jinglearn</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-4">
            JingLearn is a modern language learning platform built with the latest web technologies.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-3">Tech Stack</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>React 19 with TypeScript</li>
            <li>Vite for blazing fast development</li>
            <li>TanStack Router for type-safe routing</li>
            <li>Redux Toolkit for state management</li>
            <li>TanStack Query for server state</li>
            <li>Tailwind CSS for styling</li>
            <li>Clerk for authentication</li>
            <li>Convex for database</li>
            <li>PostHog for analytics</li>
            <li>Netlify for deployment</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
